import { render, staticRenderFns } from "./role_reservoir.vue?vue&type=template&id=6659e93d&scoped=true&"
import script from "./role_reservoir.vue?vue&type=script&lang=ts&"
export * from "./role_reservoir.vue?vue&type=script&lang=ts&"
import style0 from "./role_reservoir.vue?vue&type=style&index=0&id=6659e93d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659e93d",
  null
  
)

export default component.exports